import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '../../../../services/http.service';
import { NotificationService } from '../../../../services/notification.service';

@Component({
    selector: 'app-flat-images',
    templateUrl: './flat-images.component.html',
    styleUrls: ['./flat-images.component.scss'],
    standalone: false
})
export class FlatImagesComponent implements OnInit {

  public data: any = null;
  @Input() public flatId = null;
  public form: UntypedFormGroup;
  public loading = true;

  constructor(public activatedRoute: ActivatedRoute, public fb: UntypedFormBuilder,
              private http: HttpClient, public notify: NotificationService) {
  }

  ngOnInit() {
    if (this.flatId) {
      this.getData();
    }
  }

  getData() {
    this.http.resolvers({
      'data': this.http.post('Flat.get_common', {'flat_id': +this.flatId}),
    }).then((resolvers) => {
      this.data = resolvers['data'];
      this.pathForm();
      this.loading = false;
    });
  }

  pathForm() {
    // Фото
    const fileArr = [];
    for (const file of this.data) {
      fileArr.push({'id': file.files_id, 'filename': file.name, 'filepath': file.file});
    }
    this.form = this.fb.group({
      'files': [fileArr],
    });
  }

  saveFiles() {
    const names = [];
    const files = [];
    const types = [];
    for (const file of this.form.value.files) {
      names.push(file.filename);
      files.push(file.filepath);
      types.push(10);
    }
    this.http.post('Realty.attach_files',
      {'realty_id': this.flatId, 'names': names, 'files': files, 'types': types, 'comments': []}
    ).subscribe(
      (response) => this.onSuccess(response),
      (error) => this.onError(error)
    );
  }

  onSuccess(response) {
    this.notify.notifySuccess('Поздравляем', 'Данные успешно сохранены', 3000);
  }

  onError(error) {
    this.notify.notifyError('Ошибка', 'Ошибка:' + error, 5000);
  }

}
